$component-class: 'rating-star';

.#{$component-class} {
  --fill-color: var(--color-system-warning);
  --empty-color: var(--color-neutral-black);

  svg {
    vertical-align: top;
  }
}
